import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const { kpisPanels, datasets } = config.endpoints.metrics

const getKpisPanels = data => axios({
  method: 'GET',
  url: kpisPanels,
  data,
  headers: getHeaders(true)
})

const getDatasets = data => axios({
  method: 'GET',
  url: datasets,
  data,
  headers: getHeaders(true)
})

export default {
  getKpisPanels,
  getDatasets,
}
